module.exports = __webpack_public_path__ + "static/media/earth2.7cabeabf.jpg";